import {ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import * as aux from 'adcore-auxiliary';
import {AuthenticationService} from './helpers/authentication.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MediaService} from './helpers/media.service';
import {MessagingService} from './helpers/messaging.service';
import {TranslationService} from './helpers/translation.service';
import {NavigationEnd, Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {environment} from '../environments/environment';
import {Userpilot} from 'userpilot';
import {MessageService} from 'primeng/api';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  componentDestroyed: Subject<boolean> = new Subject();
  private authenticationInProcess = true;
  private readonly hubspotScriptId = 'hs-script-loader';
  private readonly hideHubspotChatClass = 'hide-hubspot-chat';
  private readonly proposalyScriptId = 'proposaly-bot-loader';
  private readonly proposalyBotRootId = 'proposaly-bot-root';
  private readonly proposalyWidgetSrc = 'https://cdn.proposaly.io/bot/v1/widget.js';
  private readonly proposalySupportBotId = 'BDIF6E08Oa4trw0NDQbOojJvO0NeUyGOk7bTgKyJyfc';
  private readonly proposalyLeadBotId = 'TrRBLrUJekkQWdFAU6cIQXRUyg85BCHDarrNRxXPOB8';
  private currentProposalyBotId: string | null = null;
  private proposalySweepTimers: any[] = [];

  @HostListener('window:beforeunload', ['$event'])
  handleClose(event: any): void {
    if (this.mediaService.currentAppName === 'effortless') {
      this.authenticationService.signOut();
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: any): void {
    if (['http://localhost:3000', 'http://localhost:4200', 'https://apps.adcore.com',
      'https://cloud.adcore.com',
      'https://views-test.adcore.com', 'https://amctest.adcore.com'].indexOf(event.origin) === -1){
      return;
    }
    this.messagingService.retrieveMessage(event.data || null, this);
  }

  constructor(private windowRefService: aux.WindowRefService,
              private authenticationService: AuthenticationService,
              private mediaService: MediaService,
              private messagingService: MessagingService,
              private translationService: TranslationService,
              private cdr: ChangeDetectorRef, private router: Router,
              private renderer2: Renderer2,
              private deviceService: DeviceDetectorService,
              private messageService: MessageService,
              @Inject(DOCUMENT) private _document: any) {
    this.translationService.languageChange
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((language) => {
        if (this.mediaService.currentUser) {
          this.mediaService.currentUser.language = language;
        }
        this.messagingService.sendMessage('translation', this.mediaService.currentAppName || '', '');
      });
    this.authenticationService.onAuthenticationStart
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        // console.log('authentication start on app');
        this.mediaService.isAuthenticationInProcess = true;
      });
    this.authenticationService.onAuthenticationEnd
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        // const url = decodeURIComponent(this.router.url || '');
        const url = decodeURIComponent(this.windowRefService.href || '');
        const isMobile = !this.deviceService.isDesktop() && !this.deviceService.isTablet();
        if (this.mediaService.currentUser) {
          const userId = this.mediaService.currentUser._id || this.mediaService.currentUser.id || '';
          const parameters = {
            name: this.mediaService.currentUser.name,
            email: this.mediaService.currentUser.email,
            company:  // optional
              {
                id: this.mediaService.userAdvertiserId
              }
          };
          Userpilot.identify(
            userId,
            parameters
          );
        }
        this.mediaService.isAuthenticationInProcess = false;
        if (!this.mediaService.currentUser) {
          return;
        }
        // console.log('authentication end on app', this.router.url);
        const modules = this.mediaService.modules;
        const isProfileRoute = url.includes('/mypass') || url.includes('/join');
        const isMediaBlastRoute = url.includes('/media-blast') && !url.includes('/media-blast-mobile');
        const publicRoutes = ['/mb-self-onboarding', '/unsubscribeMe', '/alerter-ignore', '/notDesktop',
            '/promote', '/audit-request'];
        if (!isProfileRoute && !publicRoutes.some(p => url.includes(p)) && this.mediaService?.currentUser &&
          (this.mediaService.goToUpgradeLogin())) {
          setTimeout(() => {
            this.router.navigateByUrl('/upgrade-login');
          });
        }
        if (!isProfileRoute && isMediaBlastRoute && !!modules.mediablast) {
          if (!this.mediaService.isMediaBlastSubscriptionActive && !isMobile) {
            this.router.navigateByUrl('/media-blast/subscription');
          }
        }
        if (!isProfileRoute && !this.mediaService.currentUser?.licenseAvailable && !this.mediaService.isAdminRole) {
          if (!publicRoutes.some(p => url.includes(p))){
            if (this.mediaService.isFeeditorPlanSelected) {
              this.router.navigateByUrl('/feeditor');
            }
            else if (this.mediaService.isFeeditorPlusPlanSelected) {
                this.router.navigateByUrl('/feeditor-plus');
            } else {
              // console.log('feeeditor or plus');
              this.router.navigateByUrl('/my-cloud');
            }
          }
        }
        // if (url.includes('/effortless') && this.mediaService.allowedEffortless) {
        //   this.router.navigateByUrl('feeditor');
        // }
        // if (!url.includes('/effortless') && this.mediaService.pureEffortless) {
        //   this.router.navigateByUrl('login');
        // }
      });
  }

  ngOnDestroy(): void {
    this.clearProposalySweepTimers();
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  private renderHubspotScript(): void {
    if (this._document.getElementById(this.hubspotScriptId)) {
      return;
    }
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = '//js.hs-scripts.com/6962858.js';
    s.text = ``;
    s.async = true;
    s.defer = true;
    s.id = this.hubspotScriptId;
    this.renderer2.appendChild(this._document.body, s);
  }

  private isSelfOnboardingRoute(url: string): boolean {
    return decodeURIComponent(url || '').includes('/mb-self-onboarding');
  }

  // Routes that show a Proposaly bot. HubSpot chat is suppressed on these so only
  // one chat bubble shows (Proposaly replaces HubSpot across all MediaBlast pages +
  // mobile + self-onboarding). Must stay in sync with desiredProposalyBotId.
  private isProposalyBotRoute(url: string): boolean {
    const decoded = decodeURIComponent(url || '');
    // '/media-blast' covers both desktop MediaBlast and '/media-blast-mobile'.
    return this.isSelfOnboardingRoute(url) || decoded.includes('/media-blast');
  }

  private syncHubspotChatVisibility(url: string): void {
    const hideHubspotChat = this.isProposalyBotRoute(url);
    if (hideHubspotChat) {
      this.renderer2.addClass(this._document.body, this.hideHubspotChatClass);
      return;
    }

    this.renderer2.removeClass(this._document.body, this.hideHubspotChatClass);
    if (environment.production) {
      this.renderHubspotScript();
    }
  }

  // Which Proposaly bot belongs on this URL (null = none).
  private desiredProposalyBotId(url: string): string | null {
    const decoded = decodeURIComponent(url || '');
    // Lead bot: the public self-onboarding funnel only.
    if (decoded.includes('/mb-self-onboarding')) {
      return this.proposalyLeadBotId;
    }
    // Support bot: the whole MediaBlast product — desktop '/media-blast/*'
    // and mobile '/media-blast-mobile/*'.
    if (decoded.includes('/media-blast')) {
      return this.proposalySupportBotId;
    }
    return null;
  }

  private renderProposalyScript(botId: string): void {
    const s = this.renderer2.createElement('script');
    s.src = this.proposalyWidgetSrc;
    s.async = true;
    s.defer = true;
    s.id = this.proposalyScriptId;
    this.renderer2.setAttribute(s, 'data-bot-id', botId);
    this.renderer2.appendChild(this._document.body, s);
  }

  private removeProposalyElement(id: string): void {
    const el = this._document.getElementById(id);
    if (el && el.parentNode) {
      this.renderer2.removeChild(el.parentNode, el);
    }
  }

  // Idempotent reconciler: make the DOM match this.currentProposalyBotId. It re-reads
  // the field on every call, so deferred invocations self-correct.
  private enforceProposalyDom(): void {
    const desired = this.currentProposalyBotId;
    const existing = this._document.getElementById(this.proposalyScriptId);
    if (!desired) {
      // No bot wanted here: remove the loader and any (possibly late-mounted) widget root.
      this.removeProposalyElement(this.proposalyScriptId);
      this.removeProposalyElement(this.proposalyBotRootId);
      return;
    }
    if (existing && existing.getAttribute('data-bot-id') === desired) {
      // Correct bot already loaded — leave it so the chat session persists across
      // in-zone navigation (e.g. self-onboarding step -> step).
      return;
    }
    // Wrong bot, or none yet: tear down and (re)inject the desired one.
    this.removeProposalyElement(this.proposalyScriptId);
    this.removeProposalyElement(this.proposalyBotRootId);
    this.renderProposalyScript(desired);
  }

  private clearProposalySweepTimers(): void {
    this.proposalySweepTimers.forEach((t) => clearTimeout(t));
    this.proposalySweepTimers = [];
  }

  private syncProposalyBot(url: string): void {
    this.currentProposalyBotId = this.desiredProposalyBotId(url);
    this.enforceProposalyDom();
    // widget.js loads async; removing the <script> does not abort an in-flight load,
    // so it can append #proposaly-bot-root after teardown. Re-enforce a couple of times
    // to sweep an orphan widget even if the user then stays on a non-bot page.
    this.clearProposalySweepTimers();
    [1500, 4000].forEach((delay) => {
      this.proposalySweepTimers.push(setTimeout(() => this.enforceProposalyDom(), delay));
    });
  }

  ngOnInit(): void {
    const initialUrl = this.router.url || this.windowRefService.href || '';
    this.syncHubspotChatVisibility(initialUrl);
    this.syncProposalyBot(initialUrl);
    this.router.events
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const navUrl = event.urlAfterRedirects || event.url || '';
          this.syncHubspotChatVisibility(navUrl);
          this.syncProposalyBot(navUrl);
        }
      });

    const nativeGeoIp = this.windowRefService.nativeGeoIp;
    if (nativeGeoIp) {
      nativeGeoIp.country((geoipResponse: any) => {
          this.mediaService.currentCountryCode = geoipResponse?.country?.iso_code || '';
        },
        (err: any) => {
          console.log('nativeGeoIp Error', err);
        });
    }
    this.authenticationService.authenticate();
    if (environment.production && !this.isProposalyBotRoute(this.router.url || this.windowRefService.href || '')) {
      this.renderHubspotScript();
    }
  }
}
